import { render, staticRenderFns } from "./adConfig.vue?vue&type=template&id=631ade12"
import script from "./adConfig.vue?vue&type=script&lang=js"
export * from "./adConfig.vue?vue&type=script&lang=js"
import style0 from "./adConfig.vue?vue&type=style&index=0&id=631ade12&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports